import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { useUtilityAlertIconStyle as f } from "./index.es5639.js";
const p = ({
  variant: o = "outline",
  size: e = 16,
  color: r = "default",
  ...i
}) => {
  const { fillColor: n, innerElementFill: s, strokeColor: C, setIsHovered: l } = f({
    color: r,
    variant: o
  });
  return /* @__PURE__ */ d(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      ...i,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M16.5 9C16.5 13.4183 12.9183 17 8.5 17C4.08172 17 0.5 13.4183 0.5 9C0.5 4.58172 4.08172 1 8.5 1C12.9183 1 16.5 4.58172 16.5 9Z",
            stroke: C,
            fill: n
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.5 4.5L9.20857 10.4053H7.81429L7.52286 4.5H9.5ZM9.23714 13.2249C9.06191 13.4082 8.8181 13.4999 8.50571 13.4999C8.18571 13.4999 7.9381 13.4102 7.76286 13.2309C7.58762 13.0516 7.5 12.7988 7.5 12.4724C7.5 12.1339 7.58571 11.878 7.75714 11.7047C7.92857 11.5315 8.1781 11.4448 8.50571 11.4448C8.82191 11.4448 9.06667 11.5335 9.24 11.7108C9.41333 11.8881 9.5 12.1419 9.5 12.4724C9.5 12.7907 9.41238 13.0415 9.23714 13.2249Z",
            fill: s
          }
        )
      ]
    }
  );
};
export {
  p as UtilityAlertIcon
};
//# sourceMappingURL=index.es448.js.map
